<div class="containers" *ngIf="!loop">
    <button id="x" (click)="onNoClick()">
    X
  </button>

    <video controls autoplay *ngIf="dataplay">
    <source src="{{imgUrl}}{{ dataplay }}" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

</div>

<div class="containers" *ngIf="dataplayer">
    <button id="x" (click)="onNoClick()">
    X
  </button>
    <div>
        <video controls autoplay #videoPlayer>
      <source src="{{imgUrl}}{{ dataplayer.projectvideo }}" type="video/mp4" /> Your browser does
      not support the video tag.
    </video>
        <!-- <div>{{ dataplayer.projectvideo }}</div> -->
        <button (click)="plusSlides(-1)" [hidden]="slideIndex === 0" class="prev"><</button>
        <button (click)="plusSlides(1)" [hidden]="slideIndex === dataplay.length-1" class="next">></button>
    </div>
</div>